"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShareData = getShareDataWithCache;
exports.getUserInfo = getUserInfo;
const { useUser } = require('@fegobull/webapi').use;
const { uid } = useUser();
const { request } = require('@futuweb/fego-render').common;
const commonApi = request.bindCommonApi('common-redpacket-share');
// 创建uuid
const cacheKey = 'common-redpacket-share-data:W4IbiX';
class ShareStorage {
    constructor(shareConfig) {
        const pathname = window.location.pathname;
        const globalContent = new URLSearchParams(window.location.search).get('global_content');
        const key = `${cacheKey}:${pathname}:${shareConfig}:${uid}:${globalContent}`;
        this.key = key;
    }
    get() {
        return localStorage.getItem(this.key) || "";
    }
    set(value) {
        localStorage.setItem(this.key, value);
    }
}
function getShareDataOnline(shareConfig) {
    return commonApi.post('get-share-data', {
        referer: window.location.href,
        shareConfig
    });
}
async function getUserInfo() {
    return commonApi.get('get-user-info');
}
/**
 * 获取分享数据
 * @param shareConfig 分享配置
 * @param retry 重试次数
 * @returns 分享数据
 */
async function getShareData(shareConfig, retry = 3) {
    const localStorage = new ShareStorage(shareConfig);
    if (localStorage.get()) {
        return localStorage.get();
    }
    try {
        const onlineData = await getShareDataOnline(shareConfig);
        if (onlineData.shortUrl) {
            localStorage.set(onlineData.shortUrl);
        }
        return onlineData.shortUrl;
    }
    catch (error) {
        if (retry > 0) {
            return getShareData(shareConfig, retry - 1);
        }
        throw error;
    }
}
async function getShareDataWithCache(shareConfig) {
    const key = `${cacheKey}:${shareConfig}`;
    if (window[key]) {
        return window[key];
    }
    window[key] = getShareData(shareConfig);
    return window[key];
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBpLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiYXBpLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBMEU2Qiw2Q0FBWTtBQUNyQyxrQ0FBVztBQTNFZixNQUFNLEVBQUUsT0FBTyxFQUFFLEdBQUcsT0FBTyxDQUFDLGtCQUFrQixDQUFDLENBQUMsR0FBRyxDQUFDO0FBQ3BELE1BQU0sRUFBRSxHQUFHLEVBQUUsR0FBRyxPQUFPLEVBQUUsQ0FBQztBQUMxQixNQUFNLEVBQUUsT0FBTyxFQUFFLEdBQUcsT0FBTyxDQUFDLHNCQUFzQixDQUFDLENBQUMsTUFBTSxDQUFDO0FBQzNELE1BQU0sU0FBUyxHQUFHLE9BQU8sQ0FBQyxhQUFhLENBQUMsd0JBQXdCLENBQUMsQ0FBQztBQUNsRSxTQUFTO0FBQ1QsTUFBTSxRQUFRLEdBQUcsb0NBQW9DLENBQUM7QUFDdEQsTUFBTSxZQUFZO0lBRWQsWUFBWSxXQUFtQjtRQUMzQixNQUFNLFFBQVEsR0FBRyxNQUFNLENBQUMsUUFBUSxDQUFDLFFBQVEsQ0FBQztRQUMxQyxNQUFNLGFBQWEsR0FBRyxJQUFJLGVBQWUsQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLE1BQU0sQ0FBQyxDQUFDLEdBQUcsQ0FBQyxnQkFBZ0IsQ0FBQyxDQUFDO1FBQ3hGLE1BQU0sR0FBRyxHQUFHLEdBQUcsUUFBUSxJQUFJLFFBQVEsSUFBSSxXQUFXLElBQUksR0FBRyxJQUFJLGFBQWEsRUFBRSxDQUFDO1FBQzdFLElBQUksQ0FBQyxHQUFHLEdBQUcsR0FBRyxDQUFDO0lBQ25CLENBQUM7SUFFRCxHQUFHO1FBQ0MsT0FBTyxZQUFZLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsSUFBSSxFQUFFLENBQUE7SUFDL0MsQ0FBQztJQUNELEdBQUcsQ0FBQyxLQUFhO1FBQ2IsWUFBWSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQzFDLENBQUM7Q0FDSjtBQUVELFNBQVMsa0JBQWtCLENBQUMsV0FBbUI7SUFDM0MsT0FBTyxTQUFTLENBQUMsSUFBSSxDQUFDLGdCQUFnQixFQUFFO1FBQ3BDLE9BQU8sRUFBRSxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUk7UUFDN0IsV0FBVztLQUNkLENBQXlCLENBQUM7QUFDL0IsQ0FBQztBQUVELEtBQUssVUFBVSxXQUFXO0lBQ3RCLE9BQU8sU0FBUyxDQUFDLEdBQUcsQ0FBQyxlQUFlLENBQTZELENBQUE7QUFDckcsQ0FBQztBQUdEOzs7OztHQUtHO0FBQ0gsS0FBSyxVQUFVLFlBQVksQ0FBQyxXQUFtQixFQUFFLEtBQUssR0FBRyxDQUFDO0lBQ3RELE1BQU0sWUFBWSxHQUFHLElBQUksWUFBWSxDQUFDLFdBQVcsQ0FBQyxDQUFDO0lBQ25ELElBQUksWUFBWSxDQUFDLEdBQUcsRUFBRSxFQUFFLENBQUM7UUFDckIsT0FBTyxZQUFZLENBQUMsR0FBRyxFQUFFLENBQUM7SUFDOUIsQ0FBQztJQUNELElBQUksQ0FBQztRQUNELE1BQU0sVUFBVSxHQUFHLE1BQU0sa0JBQWtCLENBQUMsV0FBVyxDQUFDLENBQUM7UUFDekQsSUFBSSxVQUFVLENBQUMsUUFBUSxFQUFFLENBQUM7WUFDdEIsWUFBWSxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUMsUUFBUSxDQUFDLENBQUM7UUFDMUMsQ0FBQztRQUNELE9BQU8sVUFBVSxDQUFDLFFBQVEsQ0FBQztJQUMvQixDQUFDO0lBQUMsT0FBTyxLQUFLLEVBQUUsQ0FBQztRQUNiLElBQUksS0FBSyxHQUFHLENBQUMsRUFBRSxDQUFDO1lBQ1osT0FBTyxZQUFZLENBQUMsV0FBVyxFQUFFLEtBQUssR0FBRyxDQUFDLENBQUMsQ0FBQztRQUNoRCxDQUFDO1FBQ0QsTUFBTSxLQUFLLENBQUM7SUFDaEIsQ0FBQztBQUNMLENBQUM7QUFHRCxLQUFLLFVBQVUscUJBQXFCLENBQUMsV0FBbUI7SUFDcEQsTUFBTSxHQUFHLEdBQUcsR0FBRyxRQUFRLElBQUksV0FBVyxFQUFFLENBQUM7SUFDekMsSUFBSSxNQUFNLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQztRQUNkLE9BQU8sTUFBTSxDQUFDLEdBQUcsQ0FBVyxDQUFDO0lBQ2pDLENBQUM7SUFDRCxNQUFNLENBQUMsR0FBRyxDQUFDLEdBQUcsWUFBWSxDQUFDLFdBQVcsQ0FBQyxDQUFDO0lBQ3hDLE9BQU8sTUFBTSxDQUFDLEdBQUcsQ0FBb0IsQ0FBQztBQUMxQyxDQUFDIn0=